import React, { useRef, useState, useEffect } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import axios from "axios";
import { UserProvider } from "./components/context/UserContext"; // Import UserProvider to wrap the app
import Header from "./components/Header";
import Testimonials from "./components/Testimonials";
import Footer from "./components/Footer";
import InstituteProfile from "./components/pages/InstituteProfile";
import TeacherProfilePage from "./components/pages/TeacherProfilePage";
import TutorSubmission from "./components/pages/TutorSubmission";
import InstitutePage from "./components/pages/InstitutePage";
import Teachers from "./components/pages/Teachers";
import CounterSection from "./components/CounterSection";
import FeaturedIT from "./components/FeaturedIT";
import Login from "./components/Login";
import ForgotPassword from "./components/pages/ForgotPassword";
import ResetPassword from "./components/pages/reset-password";
import Signup from "./components/Signup";
import About from "./components/pages/About";
import UserProfile from "./components/pages/UserProfile";
import WhatWeDo from "./components/WhatWeDo";
import SiteGuidelines from "./components/pages/SiteGuidelines";
import Policy from "./components/pages/policy";
import Copyright from "./components/pages/Copyright";
import AdminDash from "./components/pages/AdminDash";
import AdminLogin from "./components/pages/AdminLogin";
import TopBanner from "./components/top-banner";
import TutorComponent from "./components/TutorComponent";
import RatingComponent from "./components/RatingComponent";
import Terms from "./components/pages/Terms";

// Bangla Page Import
import HomePageBn from "./components/pages/HomePageBn";
import MaterialNetwork from "./components/pages/MaterialNetwork";

import "./App.css";

function App() {
  const [apiData, setApiData] = useState(null);
  const whatWeDoRef = useRef(null);

  useEffect(() => {
    const apiUrl = "https://server.goatteachers.com";
    axios
      .get(`${apiUrl}/teachers`)
      .then((response) => setApiData(response.data))
      .catch((error) => {
        console.error("There was an error fetching data!", error);
      });
  }, []);

  return (
    <UserProvider>
      {" "}
      {/* Wrap the entire app with UserProvider */}
      <Router>
        {/* Header with Login and Signup popups */}
        <Header />

        {/* Define the routes for different pages */}
        <Routes>
          {/* Main Landing Page Bangla */}
          {/* <Route path="/" element={<HomePageBn />} /> */}
          <Route path="/" element={<InstitutePage />} />

          {/* Main Landing Page English */}
          <Route
            path="/en"
            element={
              <div>
                <TopBanner scrollToRef={whatWeDoRef} />
                <div ref={whatWeDoRef}>
                  <WhatWeDo />
                </div>
                <CounterSection />
                <TutorComponent />
                <RatingComponent />
                <FeaturedIT />
                <Testimonials />
                {/* <LoginSection /> */}
                <Footer />
              </div>
            }
          />

          {/* Login */}
          <Route path="/login" element={<Login />} />

          {/* Signup */}
          <Route path="/signup" element={<Signup />} />

          {/* Forgot Password */}
          <Route path="/forgot-password" element={<ForgotPassword />} />

          {/* Reset Password */}
          <Route path="/reset-password" element={<ResetPassword />} />

          <Route path="/reset-password/:token" element={<ResetPassword />} />

          {/* Admin Login */}
          <Route path="/admin/login" element={<AdminLogin />} />

          {/* Material Netork Demo page */}
          <Route path="/material-network" element={<MaterialNetwork />} />

          {/* How it works */}
          <Route path="/siteguidelines" element={<SiteGuidelines />} />

          {/* About */}
          <Route path="/about" element={<About />} />

          {/* T & C */}
          <Route path="/terms" element={<Terms />} />

          {/* Privacy Policy */}
          <Route path="/policy" element={<Policy />} />

          {/* Copyright */}
          <Route path="/copyright" element={<Copyright />} />

          {/* User Profile */}
          <Route path="/userprofile" element={<UserProfile />} />

          {/* Institute Page */}
          <Route path="/rating-network" element={<InstitutePage />} />

          {/* Institute Profile Page */}
          <Route path="/institute/:id" element={<InstituteProfile />} />

          {/* Teachers List for specific institute */}
          <Route path="/institutes/:id/teachers" element={<Teachers />} />

          {/* Teacher Profile Page */}
          <Route path="/teacher/:teacherId" element={<TeacherProfilePage />} />

          {/* Goatt Tutor Submission Page */}
          <Route path="/tutor-submission" element={<TutorSubmission />} />

          {/* Admin Dashboard */}
          <Route path="/admin" element={<AdminDash />} />
        </Routes>
      </Router>
    </UserProvider>
  );
}

export default App;
